<template>
	<div id="UISources">

		<SourceManager v-bind:okanMap="okanMap" />

		<button id="addsource" class="ui_big_button"
		v-on:click="addDataSource();">
			Add data source
			<div class="ui_big_button_icon plus"></div>
		</button>

        <div class="UI_items sources">

			<div v-for="(source, indexSource) in okanMap.sources" 
			v-bind:key="indexSource"
			class="UI_item source">
				<div class="UI_item_header">
					<div class="delete_small"
					v-on:click="deleteSource(indexSource)"></div>

					<div class="UI_item_header_title">{{source.name}}</div>
					<div class="source_from">
						<div v-if="source.fromFile == false">
							{{ getProvider(source).name }} : {{  getDataset(getProvider(source), source.datasetId).name }}
						</div>
						<div v-if="source.fromFile">
							File: {{ /* source.name + '.' + source.originalContentType */}}
						</div>
						
					</div>
					<div class="UI_item_header_subtitle">
						<span v-if="source.ready"> {{source.data.features.length}} items</span>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import SourceManager from './SourceManager.vue'
import Source from '../models/Source.js'

export default {
	name: 'UISources',
	props: {
		okanMap : Object
	},
	components: {
		SourceManager
	},
	data: function() {
		return {

			varvar: true

		}
	},
	mounted() {

	},
	created() {

	},
	destroyed() {

	},
	methods : {

		init() {
		},

		getProvider(source) {
			return this.okanMap.sourceProviders.find(x => x.id == source.providerId )
		},

		getDataset(provider, datasetId) {
			return provider.datasets.find(y => y.id == datasetId)
		},

		addDataSource() {
			
			this.okanMap.tmpSource = new Source();
			this.okanMap.SourcesWindow.visible = true; 
		},

		deleteSource(indexSource) {

			this.okanMap.deleteSource(indexSource);
			/*
			// Remove the source
			this.okanMap.sources.splice(indexSource, 1);

			// Remove layers using this source
			var layersToRemove = this.okanMap.layers.filter(l => l.sourceIndex == indexSource);
			layersToRemove.forEach(ly => {
				this.okanMap.deleteLayer(ly)
			});

			// Update sourceIndex for other layers
			var layersToUpdate = this.okanMap.layers.filter(l => l.sourceIndex > indexSource);
			layersToUpdate.forEach(ly => {
				this.okanMap.layers.find(l => l.id == ly.id).sourceIndex -= 1; 
			});*/
		}

	}
}
</script>

<style scoped src="../assets/css/ui.css"></style>